const CheckedCalendarIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.33301 5V6.33333" stroke="#999999" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M16.333 5V6.33333" stroke="#999999" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M10 14.333L11.3333 15.6663L14.6667 12.333" stroke="#999999" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M5 9.66699H19.6667" stroke="#999999" strokeMiterlimit="10" strokeLinecap="square" />
      <path
        d="M18.3333 7H6.33333C5.59695 7 5 7.59695 5 8.33333V17.6667C5 18.403 5.59695 19 6.33333 19H18.3333C19.0697 19 19.6667 18.403 19.6667 17.6667V8.33333C19.6667 7.59695 19.0697 7 18.3333 7Z"
        stroke="#999999"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default CheckedCalendarIcon;
